export const subscriptionErrorParamName = 'se';
